export class QuotationDeliverable {
	public uuid: string;
	public title: number;
	public quantity: number;
	public rate: number;
	public is_taxable: boolean = true;
	// custom properties
	public temp_id: number;
	public edit: boolean = false;

	constructor(input?: any) {
		if (input) {
			Object.assign(this, input);
		}
		this.temp_id = new Date().valueOf();
		this.edit = false;
	}

	public get cost() {
		return this.quantity * this.rate;
	}

}
